import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineUserAdd } from "react-icons/ai";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import LoadableComponent from "../../../../features/Loading/LoadableComponent";
import { Ticket } from "../../../models/Ticket";
import getId from "../../../../utils/getId";
import { HiOutlineTicket } from "react-icons/hi";

interface IProps {
  passesList: Ticket[];
  loading: boolean;
  joinToExercise: (value: boolean, passId: string) => void;
  reservationList: boolean;
  exerciseStart:number;
}

const ExerciseInfoPassSelector: React.FC<IProps> = ({ passesList, loading, joinToExercise, exerciseStart }) => {
  const { t } = useTranslation();
  const [showOptions, setShowOptions] = useState(false);


  const handleClickInOption = (value: boolean, id: string) => {
    joinToExercise(value, id);
    setShowOptions(false);
  };

  const getFilteredPassesList = () => {
    const date = new Date(exerciseStart * 1000);
    const currentDate = new Date().getTime();
    const filteredPassesList = passesList.filter(
      (item) => item.validfrom <= exerciseStart && exerciseStart <= item.validto
    );
    return filteredPassesList;
  };

  return (
    <LoadableComponent loading={loading}>
      {getFilteredPassesList().length > 1 ? (
        <>
          {showOptions ? (
            <div className="custom-select">
              <button onClick={() => setShowOptions(false)} className="button medium padding-small button-outline-main">
                {t("zapisz_sie_karnetem")}
                <IoIosArrowDown className="icon" />
              </button>
              <ul className="options-list shadow">
                {getFilteredPassesList().map((option) => (
                  <React.Fragment>
                    {option.ticket === false && (
                      <li
                        className="flex-between-center"
                        key={getId(option)}
                        onClick={() => handleClickInOption(false, getId(option))}
                      >
                        <div className="flex-start-center">
                          <HiOutlineTicket className="icon" /> {option.name}
                        </div>

                        {option.entrances - option.exercises.length <= 0 && (
                          <div className="alert-red alert alert-small">Wyczerpano</div>
                        )}
                      </li>
                    )}
                  </React.Fragment>
                ))}
              </ul>
            </div>
          ) : (
            <button onClick={() => setShowOptions(true)} className="button medium padding-small button-outline-main">
              {t("zapisz_sie_karnetem")}
              <IoIosArrowUp className="icon" />
            </button>
          )}
        </>
      ) : (
        <button
          onClick={() => joinToExercise(false, "null")}
          className="button medium padding-small button-outline-main"
        >
          {t("zapisz_sie_karnetem")}
          <AiOutlineUserAdd className="icon" />
        </button>
      )}
    </LoadableComponent>
  );
};

export default ExerciseInfoPassSelector;
